export default __webpack_public_path__ + "83dddd39d20b010f99c7ab04a06af161.obj";